import cn from 'classnames';
import * as React from 'react';
import theme from './IndefiniteProgress.module.scss';
export var IndefiniteProgress = function (_a) {
    var className = _a.className, barClassName = _a.barClassName, _b = _a.width, width = _b === void 0 ? '40%' : _b;
    return (React.createElement("div", { className: cn(theme.container, className) },
        React.createElement("div", { className: theme.inner },
            React.createElement("div", { className: cn(theme.bar, barClassName), style: { width: width } }))));
};
//# sourceMappingURL=IndefiniteProgress.js.map